const shellPt = {
  ui: {
    close: 'Fechar',
    openCalendar: 'Abrir calendário',
    datePlaceholder: 'dd/mm/aaaa',
    dateInvalid: 'Data inválida',
    dateRequired: 'Data obrigatória',
    dateFormat: 'Use o formato dd/mm/aaaa',
    dateBefore: 'Data anterior ao permitido',
    dateAfter: 'Data posterior ao permitido'
  },
  status: {
    confirmed: 'Confirmado',
    pending: 'Pendente',
    cancelled: 'Cancelado',
    noShow: 'Faltou',
    completed: 'Concluído',
    unknown: 'Desconhecido',
    all: 'Todos os status'
  },
  patientTypes: {
    particular: 'Particular',
    convenio: 'Convênio',
    plano: 'Plano',
    social: 'Social',
    urgencia: 'Urgência',
    geral: 'Geral'
  },
  calendar: {
    welcome: 'Bem-vindo, {name}!',
    professionalFallback: 'Profissional',
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    newAppointment: 'Novo Agendamento',
    scheduleSlot: 'Agendar consulta',
    daySummary: 'Resumo do Dia',
    total: 'Total',
    today: 'Hoje',
    confirmed: 'Confirmados',
    pending: 'Pendentes',
    completed: 'Concluídos',
    noShow: 'Faltaram',
    cancelled: 'Cancelados',
    noSlots: 'Sem horários disponíveis neste dia conforme a grade do profissional.',
    legend: 'Legenda - Tipos de Paciente:',
    upcoming: 'Próximos Agendamentos',
    empty: 'Nenhum agendamento encontrado',
    emptyProfessional: 'Nenhum agendamento encontrado para este profissional',
    none: 'Nenhum agendamento',
    generalTitle: 'Calendário Geral',
    generalSubtitle: 'Visualize e gerencie todos os agendamentos da clínica',
    filterBy: 'Filtrar por Profissional:',
    allProfessionals: 'Todos os Profissionais',
    monthly: 'Mensal',
    quarterly: 'Trimestral',
    more: '+{count} mais',
    prev: 'Período anterior',
    next: 'Próximo período',
    minutes: '{count} min'
  },
  appointments: {
    title: 'Agendamentos',
    mine: 'Meus Agendamentos',
    subtitle: 'Gerencie todos os agendamentos da clínica',
    mineSubtitle: 'Gerencie seus agendamentos pessoais',
    new: 'Novo Agendamento',
    search: 'Buscar',
    searchPlaceholder: 'Nome, email ou telefone',
    status: 'Status',
    professional: 'Profissional',
    date: 'Data',
    allProfessionals: 'Todos os profissionais',
    list: 'Agendamentos ({count})',
    empty: 'Nenhum agendamento encontrado',
    professionalLine: 'Profissional: {name}',
    resend: 'Reenviar confirmação',
    edit: 'Editar agendamento',
    delete: 'Excluir agendamento',
    confirmSeries: 'Este horário faz parte de uma recorrência.\n\nOK exclui este e os seguintes.\nCancelar pergunta se deve excluir somente este.',
    confirmOnly: 'Excluir somente este horário?',
    confirmDelete: 'Tem certeza que deseja excluir este agendamento?',
    deleted: 'Agendamento excluído com sucesso!',
    deleteError: 'Erro ao excluir agendamento',
    loadError: 'Erro ao carregar dados',
    linkError: 'Não foi possível gerar o link de confirmação',
    noClinicTitle: 'Nenhuma Clínica Selecionada',
    noClinicBody: 'Selecione uma clínica para continuar.'
  },
  appointmentForm: {
    editTitle: 'Editar Agendamento',
    create: 'Novo Agendamento',
    openChart: 'Acessar prontuário',
    chartMissing: 'Vincule um paciente cadastrado para abrir o prontuário.',
    kind: 'Tipo',
    visit: 'Consulta',
    event: 'Evento',
    eventHint: 'Compromisso genérico, sem paciente e sem lembrete.',
    title: 'Título',
    titlePlaceholder: 'Ex.: Reunião de equipe',
    titleRequired: 'Título é obrigatório',
    description: 'Descrição',
    descriptionPlaceholder: 'O que acontece neste horário',
    professional: 'Profissional',
    professionalRequired: 'Profissional é obrigatório',
    selectProfessional: 'Selecione um profissional',
    duration: 'Duração',
    minutes: '{count} minutos',
    date: 'Data',
    time: 'Horário',
    dateLocked: 'Depois de 3 dias, a data não muda.',
    dateForwardOnly: 'A data só pode ser alterada para frente.',
    pickProfessional: 'Selecione o profissional',
    pickDate: 'Selecione a data',
    noSlots: 'Sem horários neste dia',
    pickTime: 'Selecione um horário',
    occupied: ' (ocupado)',
    noAvailability: 'Profissional sem disponibilidade nesta data.',
    patient: 'Paciente',
    clearSelection: 'Limpar seleção',
    patientPlaceholder: 'Digite nome, telefone ou e-mail',
    noPatients: 'Nenhum paciente cadastrado nesta clínica',
    patientName: 'Nome do Paciente',
    editPatient: 'Editar cadastro do paciente',
    editAction: 'Editar',
    namePlaceholder: 'Nome completo',
    nameRequired: 'Nome do paciente é obrigatório',
    phone: 'Telefone',
    phoneRequired: 'Telefone é obrigatório',
    phoneInvalid: 'Informe um telefone válido: (99) 9999-9999 ou (99) 99999-9999',
    email: 'E-mail',
    emailPlaceholder: 'email@exemplo.com',
    emailHint: 'Dados do cadastro (somente leitura). Use Editar para alterar o paciente.',
    insurance: 'Dados da carteirinha',
    cpf: 'CPF',
    cardNumber: 'Nº da carteirinha',
    notInformed: 'Não informado',
    procedure: 'Procedimento',
    selectProcedure: 'Selecione um procedimento',
    subcategory: 'Subcategoria',
    selectSubcategory: 'Selecione a subcategoria',
    subcategoryRequired: 'Selecione a subcategoria',
    procedureRequired: 'Procedimento é obrigatório',
    patientType: 'Tipo de Paciente',
    selectType: 'Selecione o tipo',
    typeHint: 'Esta informação aparecerá como tag colorida no calendário',
    recurrence: 'Recorrência',
    recurrenceNone: 'Não repete',
    recurrenceWeekly: 'Semanal',
    recurrenceBiweekly: 'Quinzenal',
    recurrenceMonthly: 'Mensal',
    repeatUntil: 'Repetir até',
    notes: 'Observações',
    notesPlaceholder: 'Observações sobre o agendamento...',
    deleteSeriesAsk: 'Este horário faz parte de uma recorrência. O que deseja excluir?',
    deleteAsk: 'Excluir este agendamento?',
    onlyThis: 'Somente este',
    delete: 'Excluir',
    thisAndFollowing: 'Este e os seguintes',
    back: 'Voltar',
    share: 'Compartilhar Link',
    generating: 'Gerando...',
    pastSlot: 'O horário deste agendamento já passou.',
    cancel: 'Cancelar',
    saving: 'Salvando...',
    update: 'Atualizar',
    createAction: 'Criar',
    pickDateTime: 'Por favor, selecione data e horário',
    dateBackward: 'A data não pode ser alterada para trás.',
    dateLockedError: 'Depois de 3 dias, a data não pode mais ser alterada.',
    statusLocked: 'Depois de 3 dias, o status só pode ser alterado para Faltou ou Cancelado.',
    patientRequired: 'Por favor, selecione um paciente ou preencha os dados do paciente',
    recurrenceUntilRequired: 'Informe até quando a recorrência vale',
    recurrenceUntilOrder: 'A data final da recorrência precisa ser igual ou posterior à data do agendamento',
    updated: 'Agendamento atualizado com sucesso!',
    createdMany: '{count} agendamentos criados',
    created: 'Agendamento criado com sucesso!',
    saveError: 'Erro ao salvar agendamento',
    deletedSeries: 'Horários da recorrência excluídos',
    deleted: 'Agendamento excluído',
    deleteError: 'Erro ao excluir agendamento',
    loadProfessionalsError: 'Erro ao carregar profissionais',
    loadPatientsError: 'Erro ao carregar pacientes',
    patientSavedFormError: 'Paciente salvo, mas não foi possível atualizar o formulário',
    shareError: 'Erro ao gerar link de compartilhamento',
    professionalFallback: 'Profissional'
  },
  confirmation: {
    title: 'Link de Confirmação Gerado',
    created: 'Agendamento Criado:',
    patient: 'Paciente:',
    professional: 'Profissional:',
    date: 'Data:',
    time: 'Horário:',
    procedure: 'Procedimento:',
    link: 'Link de Confirmação:',
    copy: 'Copiar',
    copied: 'Copiado!',
    linkHint: 'Envie este link para o paciente confirmar ou cancelar o agendamento',
    whatsapp: 'Mensagem para WhatsApp:',
    camera: 'Compartilhar pela câmera',
    qrLabel: 'QR code para abrir a mensagem no WhatsApp',
    cameraHint: 'Aponte a câmera para abrir o WhatsApp neste número com a mensagem acima.',
    sendWhatsapp: 'Enviar via WhatsApp',
    copyMessage: 'Copiar Mensagem',
    howTo: 'Como usar',
    step1: 'O paciente acessa o link sem login',
    step2: 'Pode confirmar ou cancelar pelo próprio link',
    step3: 'Cada agendamento tem um token único',
    step4: 'O status atualiza automaticamente na clínica',
    close: 'Fechar',
    linkCopied: 'Link copiado para a área de transferência!',
    copyLinkError: 'Erro ao copiar link',
    messageCopied: 'Mensagem copiada para a área de transferência!',
    copyMessageError: 'Erro ao copiar mensagem'
  },
  chart: {
    open: 'Ficha',
    openTitle: 'Abrir ficha do paciente',
    missing: 'Paciente não encontrado no cadastro. Cadastre-o em Pacientes para abrir a ficha.',
    openError: 'Erro ao abrir ficha do paciente'
  },
  patients: {
    mine: 'Meus Pacientes',
    title: 'Gerenciar Pacientes',
    mineSubtitle: 'Gerencie seus pacientes pessoais',
    subtitle: 'Gerencie todos os pacientes da clínica',
    new: 'Novo Paciente',
    list: 'Pacientes ({count})',
    search: 'Buscar pacientes',
    searchPlaceholder: 'Nome, email ou telefone',
    filterStatus: 'Filtrar por status',
    active: 'Ativos',
    inactive: 'Inativos',
    all: 'Todos',
    empty: 'Nenhum paciente encontrado',
    activeBadge: 'Ativo',
    inactiveBadge: 'Inativo',
    notInformed: 'Não informado',
    invalidDate: 'Data inválida',
    professionalLine: 'Profissional: {name}',
    unassigned: 'Não atribuído',
    notes: 'Observações: {notes}',
    clinicalNotes: '{count} nota(s) clínica(s)',
    view: 'Ver prontuário',
    edit: 'Editar paciente',
    deactivate: 'Desativar paciente',
    activate: 'Ativar paciente',
    showing: 'Mostrando {start}–{end} de {total}',
    previous: 'Anterior',
    next: 'Próxima',
    prevPage: 'Página anterior',
    nextPage: 'Próxima página',
    page: 'Página {page} de {total}',
    activated: 'Paciente ativado com sucesso!',
    deactivated: 'Paciente desativado com sucesso!',
    toggleError: 'Erro ao alterar status do paciente',
    noClinicTitle: 'Nenhuma Clínica Selecionada',
    noClinicBody: 'Selecione uma clínica para continuar.'
  },
  patientChart: {
    notFound: 'Paciente não encontrado',
    notFoundBody: 'O prontuário não existe ou pertence a outra clínica.',
    back: 'Voltar para pacientes',
    breadcrumb: 'Caminho',
    patients: 'Pacientes',
    record: 'Prontuário',
    subtitle: 'Prontuário e histórico de consultas',
    sections: 'Seções do prontuário',
    loadError: 'Erro ao carregar o prontuário',
    mediaError: 'Erro ao carregar mídias',
    overview: 'Visão geral',
    odontogram: 'Odontograma',
    hof: 'HOF',
    ortho: 'Ortodontia',
    media: 'Mídias',
    overviewTitle: 'Visão geral',
    overviewBody: 'Identificação, informações clínicas e registros do prontuário.',
    editRegistration: 'Editar cadastro'
  },
  users: {
    title: 'Gestão de Usuários',
    subtitle: 'Gerencie profissionais, secretárias e administradores',
    newInvite: 'Novo Convite',
    tabs: 'Abas',
    usersCount: 'Usuários ({count})',
    invitesShort: 'Convites ({count})',
    invites: 'Convites Pendentes ({count})',
    edit: 'Editar Usuário',
    name: 'Nome',
    nameRequired: 'Nome é obrigatório',
    namePlaceholder: 'Nome completo',
    email: 'Email',
    emailRequired: 'Email é obrigatório',
    emailInvalid: 'Email inválido',
    emailPlaceholder: 'email@exemplo.com',
    phone: 'Telefone',
    newPassword: 'Nova Senha (deixe em branco para manter a atual)',
    passwordShort: 'Senha deve ter pelo menos 6 caracteres',
    passwordPlaceholder: 'Nova senha (opcional)',
    role: 'Função',
    roleRequired: 'Função é obrigatória',
    selectRole: 'Selecione uma função',
    admin: 'Administrador',
    professional: 'Profissional',
    secretary: 'Secretária',
    secretaryLocked: 'O plano Individual não inclui secretárias.',
    active: 'Usuário ativo',
    specialty: 'Especialidade',
    selectSpecialty: 'Selecione a especialidade',
    duration: 'Duração padrão dos atendimentos',
    minutes: '{count} minutos',
    hoursHint: 'Esses horários serão aplicados automaticamente quando o usuário aceitar o convite.',
    clinicDefaultHours: 'Usando horários padrão da clínica',
    cancel: 'Cancelar',
    saving: 'Salvando...',
    update: 'Atualizar',
    create: 'Criar',
    deactivate: 'Desativar usuário',
    activate: 'Ativar usuário',
    editUser: 'Editar usuário',
    deleteUser: 'Deletar usuário',
    inviteCreatedOn: 'Convite criado em {date}',
    sendingEmail: 'Enviando e-mail...',
    sendEmail: 'Enviar convite por e-mail',
    copyLink: 'Copiar link do convite',
    cancelInvite: 'Cancelar convite',
    deleteInvite: 'Deletar convite',
    noClinic: 'Nenhuma clínica selecionada',
    noClinicTitle: 'Nenhuma Clínica Selecionada',
    noClinicBody: 'Selecione uma clínica para continuar.',
    deniedTitle: 'Acesso Negado',
    deniedBody: 'Você não tem permissão para gerenciar usuários.',
    updated: 'Usuário atualizado com sucesso!',
    inviteCreated: 'Convite criado! Link copiado e e-mail enviado.',
    saveError: 'Erro ao salvar: {message}',
    emailSent: 'E-mail de convite enviado',
    emailError: 'Não foi possível enviar o e-mail',
    confirmDeactivate: 'Tem certeza que deseja desativar este usuário?',
    deactivated: 'Usuário desativado com sucesso!',
    deleteError: 'Erro ao deletar usuário',
    activated: 'Usuário ativado com sucesso!',
    userDeactivated: 'Usuário desativado com sucesso!',
    statusError: 'Erro ao alterar status do usuário',
    linkCopied: 'Link copiado para a área de transferência!',
    copyError: 'Erro ao copiar link',
    confirmCancelInvite: 'Tem certeza que deseja cancelar este convite?',
    inviteCancelled: 'Convite cancelado com sucesso!',
    cancelInviteError: 'Erro ao cancelar convite',
    confirmDeleteInvite: 'Tem certeza que deseja deletar este convite?',
    inviteDeleted: 'Convite deletado com sucesso!',
    deleteInviteError: 'Erro ao deletar convite'
  },
  settings: {
    title: 'Configurações',
    subtitle: 'Perfil da clínica, assinatura, grade padrão e mensagem de confirmação',
    readOnly: 'Você pode visualizar as configurações, mas apenas administradores podem editá-las.',
    clinic: 'Dados da clínica',
    name: 'Nome',
    description: 'Descrição',
    address: 'Endereço',
    phone: 'Telefone',
    email: 'E-mail',
    cnpj: 'CNPJ',
    schedule: 'Agenda padrão',
    duration: 'Duração padrão (minutos)',
    interval: 'Intervalo da grade',
    minutes: '{count} min',
    hoursHint: 'Usado quando o profissional ainda não tem horários próprios configurados.',
    confirmation: 'Mensagem de confirmação',
    variables: 'Variáveis: {paciente}, {profissional}, {data}, {horario}, {link}',
    saving: 'Salvando...',
    save: 'Salvar configurações',
    noClinic: 'Nenhuma clínica selecionada',
    noClinicTitle: 'Nenhuma clínica selecionada',
    noClinicBody: 'Selecione uma clínica para gerenciar as configurações.',
    adminOnly: 'Apenas administradores podem alterar as configurações',
    saved: 'Configurações salvas com sucesso',
    saveError: 'Erro ao salvar configurações: {message}'
  },
  billing: {
    title: 'Assinatura e pagamento',
    plan: 'Plano',
    noPaidPlan: 'Nenhum plano pago',
    status: 'Status',
    tester: 'Conta de teste',
    method: 'Método',
    methodPix: 'Pix (OpenPix)',
    methodCard: 'Cartão (Stripe)',
    cycle: 'Ciclo',
    annual: 'Anual',
    monthly: 'Mensal',
    perMonth: '/mês',
    renewal: 'Próxima renovação',
    notConfigured: 'Pagamento ainda sem credenciais. Stripe (cartão) e OpenPix (Pix) podem ser ligados depois do cadastro.',
    renew: 'Renovar plano',
    subscribe: 'Assinar plano',
    opening: 'Abrindo...',
    portal: 'Gerenciar no portal Stripe',
    portalError: 'Não foi possível abrir o portal Stripe',
    refresh: 'Atualizar status',
    bannerStatus: 'Assinatura: {status}',
    bannerBody: 'Regularize o pagamento para manter o plano da clínica ativo.',
    bannerCta: 'Ir para o checkout',
    sub: {
      active: 'Ativa',
      trialing: 'Período de teste',
      past_due: 'Pagamento atrasado',
      unpaid: 'Não paga',
      canceled: 'Cancelada',
      incomplete: 'Incompleta',
      incomplete_expired: 'Expirada',
      none: 'Sem assinatura'
    }
  },
  auth: {
    backHome: 'Voltar ao Início',
    createAccount: 'Criar Conta',
    subtitle: 'Sistema de Agendamento',
    email: 'Email',
    emailPlaceholder: 'seu@email.com',
    password: 'Senha',
    showPassword: 'Mostrar senha',
    hidePassword: 'Ocultar senha',
    signingIn: 'Entrando...',
    signIn: 'Entrar',
    forgot: 'Esqueci minha senha',
    noAccount: 'Não tem uma conta?',
    createAdmin: 'Crie uma conta de administrador',
    toStart: 'para começar.',
    fillAll: 'Por favor, preencha todos os campos',
    signedIn: 'Login realizado com sucesso!',
    badCredentials: 'Email ou senha incorretos.',
    tooMany: 'Muitas tentativas. Tente novamente em alguns minutos.',
    loginError: 'Erro no login. Verifique suas credenciais.',
    backLogin: 'Voltar ao login',
    resetTitle: 'Recupere sua senha',
    resetBody: 'Informe o e-mail da sua conta. Se ele estiver cadastrado, enviaremos um link para criar uma nova senha.',
    resetSent: 'Se o e-mail estiver cadastrado, você receberá as instruções em instantes. O link expira em 1 hora.',
    sending: 'Enviando...',
    sendLink: 'Enviar link',
    resetError: 'Não foi possível enviar o e-mail de recuperação.'
  }
};

const shellEn = {
  ui: {
    close: 'Close',
    openCalendar: 'Open calendar',
    datePlaceholder: 'dd/mm/yyyy',
    dateInvalid: 'Invalid date',
    dateRequired: 'Date is required',
    dateFormat: 'Use the dd/mm/yyyy format',
    dateBefore: 'Date is before the allowed range',
    dateAfter: 'Date is after the allowed range'
  },
  status: {
    confirmed: 'Confirmed',
    pending: 'Pending',
    cancelled: 'Cancelled',
    noShow: 'No-show',
    completed: 'Completed',
    unknown: 'Unknown',
    all: 'All statuses'
  },
  patientTypes: {
    particular: 'Private',
    convenio: 'Insurance',
    plano: 'Plan',
    social: 'Social',
    urgencia: 'Urgent',
    geral: 'General'
  },
  calendar: {
    welcome: 'Welcome, {name}!',
    professionalFallback: 'Professional',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    newAppointment: 'New appointment',
    scheduleSlot: 'Schedule visit',
    daySummary: 'Day summary',
    total: 'Total',
    today: 'Today',
    confirmed: 'Confirmed',
    pending: 'Pending',
    completed: 'Completed',
    noShow: 'No-shows',
    cancelled: 'Cancelled',
    noSlots: 'No times available this day for this professional’s schedule.',
    legend: 'Legend — patient types:',
    upcoming: 'Upcoming appointments',
    empty: 'No appointments found',
    emptyProfessional: 'No appointments found for this professional',
    none: 'No appointments',
    generalTitle: 'General Calendar',
    generalSubtitle: 'View and manage every appointment in the clinic',
    filterBy: 'Filter by professional:',
    allProfessionals: 'All professionals',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    more: '+{count} more',
    prev: 'Previous period',
    next: 'Next period',
    minutes: '{count} min'
  },
  appointments: {
    title: 'Appointments',
    mine: 'My appointments',
    subtitle: 'Manage every appointment in the clinic',
    mineSubtitle: 'Manage your own appointments',
    new: 'New appointment',
    search: 'Search',
    searchPlaceholder: 'Name, email or phone',
    status: 'Status',
    professional: 'Professional',
    date: 'Date',
    allProfessionals: 'All professionals',
    list: 'Appointments ({count})',
    empty: 'No appointments found',
    professionalLine: 'Professional: {name}',
    resend: 'Resend confirmation',
    edit: 'Edit appointment',
    delete: 'Delete appointment',
    confirmSeries: 'This time is part of a series.\n\nOK deletes this one and the following.\nCancel asks whether to delete only this one.',
    confirmOnly: 'Delete only this time?',
    confirmDelete: 'Delete this appointment?',
    deleted: 'Appointment deleted.',
    deleteError: 'Could not delete the appointment',
    loadError: 'Could not load data',
    linkError: 'Could not generate the confirmation link',
    noClinicTitle: 'No clinic selected',
    noClinicBody: 'Select a clinic to continue.'
  },
  appointmentForm: {
    editTitle: 'Edit appointment',
    create: 'New appointment',
    openChart: 'Open chart',
    chartMissing: 'Link a registered patient to open the chart.',
    kind: 'Type',
    visit: 'Visit',
    event: 'Event',
    eventHint: 'A general block, with no patient and no reminder.',
    title: 'Title',
    titlePlaceholder: 'E.g. team meeting',
    titleRequired: 'Title is required',
    description: 'Description',
    descriptionPlaceholder: 'What happens in this slot',
    professional: 'Professional',
    professionalRequired: 'Professional is required',
    selectProfessional: 'Select a professional',
    duration: 'Duration',
    minutes: '{count} minutes',
    date: 'Date',
    time: 'Time',
    dateLocked: 'After 3 days the date is locked.',
    dateForwardOnly: 'The date can only be moved forward.',
    pickProfessional: 'Select the professional',
    pickDate: 'Select the date',
    noSlots: 'No times this day',
    pickTime: 'Select a time',
    occupied: ' (taken)',
    noAvailability: 'This professional has no availability on this date.',
    patient: 'Patient',
    clearSelection: 'Clear selection',
    patientPlaceholder: 'Type a name, phone or email',
    noPatients: 'No patients registered in this clinic',
    patientName: 'Patient name',
    editPatient: 'Edit patient record',
    editAction: 'Edit',
    namePlaceholder: 'Full name',
    nameRequired: 'Patient name is required',
    phone: 'Phone',
    phoneRequired: 'Phone is required',
    phoneInvalid: 'Enter a valid phone: (99) 9999-9999 or (99) 99999-9999',
    email: 'Email',
    emailPlaceholder: 'email@example.com',
    emailHint: 'Record data (read only). Use Edit to change the patient.',
    insurance: 'Insurance card',
    cpf: 'CPF',
    cardNumber: 'Card number',
    notInformed: 'Not provided',
    procedure: 'Procedure',
    selectProcedure: 'Select a procedure',
    subcategory: 'Subcategory',
    selectSubcategory: 'Select the subcategory',
    subcategoryRequired: 'Select the subcategory',
    procedureRequired: 'Procedure is required',
    patientType: 'Patient type',
    selectType: 'Select a type',
    typeHint: 'This shows up as a colored tag on the calendar',
    recurrence: 'Recurrence',
    recurrenceNone: 'Does not repeat',
    recurrenceWeekly: 'Weekly',
    recurrenceBiweekly: 'Every two weeks',
    recurrenceMonthly: 'Monthly',
    repeatUntil: 'Repeat until',
    notes: 'Notes',
    notesPlaceholder: 'Notes about this appointment...',
    deleteSeriesAsk: 'This time is part of a series. What should be deleted?',
    deleteAsk: 'Delete this appointment?',
    onlyThis: 'Only this one',
    delete: 'Delete',
    thisAndFollowing: 'This and the following',
    back: 'Back',
    share: 'Share link',
    generating: 'Generating...',
    pastSlot: 'This appointment time has already passed.',
    cancel: 'Cancel',
    saving: 'Saving...',
    update: 'Update',
    createAction: 'Create',
    pickDateTime: 'Please select a date and time',
    dateBackward: 'The date cannot be moved backward.',
    dateLockedError: 'After 3 days the date can no longer be changed.',
    statusLocked: 'After 3 days the status can only be changed to No-show or Cancelled.',
    patientRequired: 'Select a patient or fill in the patient details',
    recurrenceUntilRequired: 'Choose how long the recurrence lasts',
    recurrenceUntilOrder: 'The recurrence end date must be on or after the appointment date',
    updated: 'Appointment updated.',
    createdMany: '{count} appointments created',
    created: 'Appointment created.',
    saveError: 'Could not save the appointment',
    deletedSeries: 'Recurring times deleted',
    deleted: 'Appointment deleted',
    deleteError: 'Could not delete the appointment',
    loadProfessionalsError: 'Could not load professionals',
    loadPatientsError: 'Could not load patients',
    patientSavedFormError: 'Patient saved, but the form could not be refreshed',
    shareError: 'Could not generate the share link',
    professionalFallback: 'Professional'
  },
  confirmation: {
    title: 'Confirmation link ready',
    created: 'Appointment created:',
    patient: 'Patient:',
    professional: 'Professional:',
    date: 'Date:',
    time: 'Time:',
    procedure: 'Procedure:',
    link: 'Confirmation link:',
    copy: 'Copy',
    copied: 'Copied!',
    linkHint: 'Send this link so the patient can confirm or cancel',
    whatsapp: 'WhatsApp message:',
    camera: 'Share with the camera',
    qrLabel: 'QR code to open the WhatsApp message',
    cameraHint: 'Point the camera to open WhatsApp on this number with the message above.',
    sendWhatsapp: 'Send via WhatsApp',
    copyMessage: 'Copy message',
    howTo: 'How it works',
    step1: 'The patient opens the link without signing in',
    step2: 'They can confirm or cancel from the link',
    step3: 'Each appointment has a unique token',
    step4: 'The status updates in the clinic automatically',
    close: 'Close',
    linkCopied: 'Link copied to the clipboard!',
    copyLinkError: 'Could not copy the link',
    messageCopied: 'Message copied to the clipboard!',
    copyMessageError: 'Could not copy the message'
  },
  chart: {
    open: 'Chart',
    openTitle: 'Open patient chart',
    missing: 'Patient not found in the registry. Add them under Patients to open the chart.',
    openError: 'Could not open the patient chart'
  },
  patients: {
    mine: 'My patients',
    title: 'Manage patients',
    mineSubtitle: 'Manage your own patients',
    subtitle: 'Manage every patient in the clinic',
    new: 'New patient',
    list: 'Patients ({count})',
    search: 'Search patients',
    searchPlaceholder: 'Name, email or phone',
    filterStatus: 'Filter by status',
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
    empty: 'No patients found',
    activeBadge: 'Active',
    inactiveBadge: 'Inactive',
    notInformed: 'Not provided',
    invalidDate: 'Invalid date',
    professionalLine: 'Professional: {name}',
    unassigned: 'Unassigned',
    notes: 'Notes: {notes}',
    clinicalNotes: '{count} clinical note(s)',
    view: 'View chart',
    edit: 'Edit patient',
    deactivate: 'Deactivate patient',
    activate: 'Activate patient',
    showing: 'Showing {start}–{end} of {total}',
    previous: 'Previous',
    next: 'Next',
    prevPage: 'Previous page',
    nextPage: 'Next page',
    page: 'Page {page} of {total}',
    activated: 'Patient activated.',
    deactivated: 'Patient deactivated.',
    toggleError: 'Could not change the patient status',
    noClinicTitle: 'No clinic selected',
    noClinicBody: 'Select a clinic to continue.'
  },
  patientChart: {
    notFound: 'Patient not found',
    notFoundBody: 'This chart does not exist or belongs to another clinic.',
    back: 'Back to patients',
    breadcrumb: 'Breadcrumb',
    patients: 'Patients',
    record: 'Chart',
    subtitle: 'Chart and visit history',
    sections: 'Chart sections',
    loadError: 'Could not load the chart',
    mediaError: 'Could not load media',
    overview: 'Overview',
    odontogram: 'Odontogram',
    hof: 'HOF',
    ortho: 'Orthodontics',
    media: 'Media',
    overviewTitle: 'Overview',
    overviewBody: 'Identification, clinical information and chart records.',
    editRegistration: 'Edit record'
  },
  users: {
    title: 'User management',
    subtitle: 'Manage professionals, secretaries and administrators',
    newInvite: 'New invite',
    tabs: 'Tabs',
    usersCount: 'Users ({count})',
    invitesShort: 'Invites ({count})',
    invites: 'Pending invites ({count})',
    edit: 'Edit user',
    name: 'Name',
    nameRequired: 'Name is required',
    namePlaceholder: 'Full name',
    email: 'Email',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email',
    emailPlaceholder: 'email@example.com',
    phone: 'Phone',
    newPassword: 'New password (leave blank to keep the current one)',
    passwordShort: 'Password must be at least 6 characters',
    passwordPlaceholder: 'New password (optional)',
    role: 'Role',
    roleRequired: 'Role is required',
    selectRole: 'Select a role',
    admin: 'Administrator',
    professional: 'Professional',
    secretary: 'Secretary',
    secretaryLocked: 'The Individual plan does not include secretaries.',
    active: 'Active user',
    specialty: 'Specialty',
    selectSpecialty: 'Select a specialty',
    duration: 'Default visit duration',
    minutes: '{count} minutes',
    hoursHint: 'These hours are applied automatically when the user accepts the invite.',
    clinicDefaultHours: 'Using the clinic default hours',
    cancel: 'Cancel',
    saving: 'Saving...',
    update: 'Update',
    create: 'Create',
    deactivate: 'Deactivate user',
    activate: 'Activate user',
    editUser: 'Edit user',
    deleteUser: 'Delete user',
    inviteCreatedOn: 'Invite created on {date}',
    sendingEmail: 'Sending email...',
    sendEmail: 'Send invite by email',
    copyLink: 'Copy invite link',
    cancelInvite: 'Cancel invite',
    deleteInvite: 'Delete invite',
    noClinic: 'No clinic selected',
    noClinicTitle: 'No clinic selected',
    noClinicBody: 'Select a clinic to continue.',
    deniedTitle: 'Access denied',
    deniedBody: 'You do not have permission to manage users.',
    updated: 'User updated.',
    inviteCreated: 'Invite created. Link copied and email sent.',
    saveError: 'Could not save: {message}',
    emailSent: 'Invite email sent',
    emailError: 'Could not send the email',
    confirmDeactivate: 'Deactivate this user?',
    deactivated: 'User deactivated.',
    deleteError: 'Could not delete the user',
    activated: 'User activated.',
    userDeactivated: 'User deactivated.',
    statusError: 'Could not change the user status',
    linkCopied: 'Link copied to the clipboard!',
    copyError: 'Could not copy the link',
    confirmCancelInvite: 'Cancel this invite?',
    inviteCancelled: 'Invite cancelled.',
    cancelInviteError: 'Could not cancel the invite',
    confirmDeleteInvite: 'Delete this invite?',
    inviteDeleted: 'Invite deleted.',
    deleteInviteError: 'Could not delete the invite'
  },
  settings: {
    title: 'Settings',
    subtitle: 'Clinic profile, subscription, default schedule and confirmation message',
    readOnly: 'You can view these settings. Only administrators can edit them.',
    clinic: 'Clinic details',
    name: 'Name',
    description: 'Description',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    cnpj: 'CNPJ',
    schedule: 'Default schedule',
    duration: 'Default duration (minutes)',
    interval: 'Grid interval',
    minutes: '{count} min',
    hoursHint: 'Used when the professional does not have their own hours yet.',
    confirmation: 'Confirmation message',
    variables: 'Variables: {paciente}, {profissional}, {data}, {horario}, {link}',
    saving: 'Saving...',
    save: 'Save settings',
    noClinic: 'No clinic selected',
    noClinicTitle: 'No clinic selected',
    noClinicBody: 'Select a clinic to manage settings.',
    adminOnly: 'Only administrators can change settings',
    saved: 'Settings saved',
    saveError: 'Could not save settings: {message}'
  },
  billing: {
    title: 'Subscription and payment',
    plan: 'Plan',
    noPaidPlan: 'No paid plan',
    status: 'Status',
    tester: 'Test account',
    method: 'Method',
    methodPix: 'Pix (OpenPix)',
    methodCard: 'Card (Stripe)',
    cycle: 'Cycle',
    annual: 'Annual',
    monthly: 'Monthly',
    perMonth: '/mo',
    renewal: 'Next renewal',
    notConfigured: 'Payments are not configured yet. Stripe (card) and OpenPix (Pix) can be connected after signup.',
    renew: 'Renew plan',
    subscribe: 'Subscribe',
    opening: 'Opening...',
    portal: 'Manage in the Stripe portal',
    portalError: 'Could not open the Stripe portal',
    refresh: 'Refresh status',
    bannerStatus: 'Subscription: {status}',
    bannerBody: 'Update the payment to keep the clinic plan active.',
    bannerCta: 'Go to checkout',
    sub: {
      active: 'Active',
      trialing: 'Trial',
      past_due: 'Past due',
      unpaid: 'Unpaid',
      canceled: 'Canceled',
      incomplete: 'Incomplete',
      incomplete_expired: 'Expired',
      none: 'No subscription'
    }
  },
  auth: {
    backHome: 'Back to home',
    createAccount: 'Create account',
    subtitle: 'Scheduling system',
    email: 'Email',
    emailPlaceholder: 'you@email.com',
    password: 'Password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    signingIn: 'Signing in...',
    signIn: 'Sign in',
    forgot: 'Forgot my password',
    noAccount: 'Don’t have an account?',
    createAdmin: 'Create an administrator account',
    toStart: 'to get started.',
    fillAll: 'Please fill in every field',
    signedIn: 'Signed in.',
    badCredentials: 'Incorrect email or password.',
    tooMany: 'Too many attempts. Try again in a few minutes.',
    loginError: 'Sign-in failed. Check your credentials.',
    backLogin: 'Back to sign in',
    resetTitle: 'Reset your password',
    resetBody: 'Enter your account email. If it is registered, we will send a link to create a new password.',
    resetSent: 'If the email is registered, you will receive instructions shortly. The link expires in 1 hour.',
    sending: 'Sending...',
    sendLink: 'Send link',
    resetError: 'Could not send the recovery email.'
  }
};

const shellEs = {
  ui: {
    close: 'Cerrar',
    openCalendar: 'Abrir calendario',
    datePlaceholder: 'dd/mm/aaaa',
    dateInvalid: 'Fecha inválida',
    dateRequired: 'La fecha es obligatoria',
    dateFormat: 'Use el formato dd/mm/aaaa',
    dateBefore: 'Fecha anterior a lo permitido',
    dateAfter: 'Fecha posterior a lo permitido'
  },
  status: {
    confirmed: 'Confirmada',
    pending: 'Pendiente',
    cancelled: 'Cancelada',
    noShow: 'No asistió',
    completed: 'Completada',
    unknown: 'Desconocido',
    all: 'Todos los estados'
  },
  patientTypes: {
    particular: 'Particular',
    convenio: 'Convenio',
    plano: 'Plan',
    social: 'Social',
    urgencia: 'Urgencia',
    geral: 'General'
  },
  calendar: {
    welcome: 'Bienvenido, {name}!',
    professionalFallback: 'Profesional',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    newAppointment: 'Nueva cita',
    scheduleSlot: 'Agendar consulta',
    daySummary: 'Resumen del día',
    total: 'Total',
    today: 'Hoy',
    confirmed: 'Confirmadas',
    pending: 'Pendientes',
    completed: 'Completadas',
    noShow: 'No asistieron',
    cancelled: 'Canceladas',
    noSlots: 'No hay horarios este día según la agenda del profesional.',
    legend: 'Leyenda — tipos de paciente:',
    upcoming: 'Próximas citas',
    empty: 'No se encontraron citas',
    emptyProfessional: 'No se encontraron citas para este profesional',
    none: 'Ninguna cita',
    generalTitle: 'Calendario general',
    generalSubtitle: 'Vea y gestione todas las citas de la clínica',
    filterBy: 'Filtrar por profesional:',
    allProfessionals: 'Todos los profesionales',
    monthly: 'Mensual',
    quarterly: 'Trimestral',
    more: '+{count} más',
    prev: 'Período anterior',
    next: 'Período siguiente',
    minutes: '{count} min'
  },
  appointments: {
    title: 'Citas',
    mine: 'Mis citas',
    subtitle: 'Gestione todas las citas de la clínica',
    mineSubtitle: 'Gestione sus citas',
    new: 'Nueva cita',
    search: 'Buscar',
    searchPlaceholder: 'Nombre, correo o teléfono',
    status: 'Estado',
    professional: 'Profesional',
    date: 'Fecha',
    allProfessionals: 'Todos los profesionales',
    list: 'Citas ({count})',
    empty: 'No se encontraron citas',
    professionalLine: 'Profesional: {name}',
    resend: 'Reenviar confirmación',
    edit: 'Editar cita',
    delete: 'Eliminar cita',
    confirmSeries: 'Este horario forma parte de una serie.\n\nAceptar elimina este y los siguientes.\nCancelar pregunta si debe eliminar solo este.',
    confirmOnly: '¿Eliminar solo este horario?',
    confirmDelete: '¿Eliminar esta cita?',
    deleted: 'Cita eliminada.',
    deleteError: 'No se pudo eliminar la cita',
    loadError: 'No se pudieron cargar los datos',
    linkError: 'No se pudo generar el enlace de confirmación',
    noClinicTitle: 'Ninguna clínica seleccionada',
    noClinicBody: 'Seleccione una clínica para continuar.'
  },
  appointmentForm: {
    editTitle: 'Editar cita',
    create: 'Nueva cita',
    openChart: 'Abrir ficha',
    chartMissing: 'Vincule un paciente registrado para abrir la ficha.',
    kind: 'Tipo',
    visit: 'Consulta',
    event: 'Evento',
    eventHint: 'Compromiso genérico, sin paciente y sin recordatorio.',
    title: 'Título',
    titlePlaceholder: 'Ej.: reunión de equipo',
    titleRequired: 'El título es obligatorio',
    description: 'Descripción',
    descriptionPlaceholder: 'Qué ocurre en este horario',
    professional: 'Profesional',
    professionalRequired: 'El profesional es obligatorio',
    selectProfessional: 'Seleccione un profesional',
    duration: 'Duración',
    minutes: '{count} minutos',
    date: 'Fecha',
    time: 'Horario',
    dateLocked: 'Después de 3 días la fecha no cambia.',
    dateForwardOnly: 'La fecha solo puede moverse hacia adelante.',
    pickProfessional: 'Seleccione el profesional',
    pickDate: 'Seleccione la fecha',
    noSlots: 'Sin horarios este día',
    pickTime: 'Seleccione un horario',
    occupied: ' (ocupado)',
    noAvailability: 'El profesional no tiene disponibilidad en esta fecha.',
    patient: 'Paciente',
    clearSelection: 'Limpiar selección',
    patientPlaceholder: 'Escriba nombre, teléfono o correo',
    noPatients: 'No hay pacientes registrados en esta clínica',
    patientName: 'Nombre del paciente',
    editPatient: 'Editar ficha del paciente',
    editAction: 'Editar',
    namePlaceholder: 'Nombre completo',
    nameRequired: 'El nombre del paciente es obligatorio',
    phone: 'Teléfono',
    phoneRequired: 'El teléfono es obligatorio',
    phoneInvalid: 'Indique un teléfono válido: (99) 9999-9999 o (99) 99999-9999',
    email: 'Correo',
    emailPlaceholder: 'correo@ejemplo.com',
    emailHint: 'Datos del registro (solo lectura). Use Editar para cambiar el paciente.',
    insurance: 'Datos de la credencial',
    cpf: 'CPF',
    cardNumber: 'N.º de credencial',
    notInformed: 'No informado',
    procedure: 'Procedimiento',
    selectProcedure: 'Seleccione un procedimiento',
    subcategory: 'Subcategoría',
    selectSubcategory: 'Seleccione la subcategoría',
    subcategoryRequired: 'Seleccione la subcategoría',
    procedureRequired: 'El procedimiento es obligatorio',
    patientType: 'Tipo de paciente',
    selectType: 'Seleccione el tipo',
    typeHint: 'Esta información aparece como etiqueta de color en el calendario',
    recurrence: 'Recurrencia',
    recurrenceNone: 'No se repite',
    recurrenceWeekly: 'Semanal',
    recurrenceBiweekly: 'Quincenal',
    recurrenceMonthly: 'Mensual',
    repeatUntil: 'Repetir hasta',
    notes: 'Observaciones',
    notesPlaceholder: 'Observaciones de la cita...',
    deleteSeriesAsk: 'Este horario forma parte de una serie. ¿Qué desea eliminar?',
    deleteAsk: '¿Eliminar esta cita?',
    onlyThis: 'Solo esta',
    delete: 'Eliminar',
    thisAndFollowing: 'Esta y las siguientes',
    back: 'Volver',
    share: 'Compartir enlace',
    generating: 'Generando...',
    pastSlot: 'El horario de esta cita ya pasó.',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    update: 'Actualizar',
    createAction: 'Crear',
    pickDateTime: 'Seleccione fecha y horario',
    dateBackward: 'La fecha no puede moverse hacia atrás.',
    dateLockedError: 'Después de 3 días la fecha ya no se puede cambiar.',
    statusLocked: 'Después de 3 días el estado solo puede cambiar a No asistió o Cancelada.',
    patientRequired: 'Seleccione un paciente o complete sus datos',
    recurrenceUntilRequired: 'Indique hasta cuándo vale la recurrencia',
    recurrenceUntilOrder: 'La fecha final de la recurrencia debe ser igual o posterior a la de la cita',
    updated: 'Cita actualizada.',
    createdMany: '{count} citas creadas',
    created: 'Cita creada.',
    saveError: 'No se pudo guardar la cita',
    deletedSeries: 'Horarios de la serie eliminados',
    deleted: 'Cita eliminada',
    deleteError: 'No se pudo eliminar la cita',
    loadProfessionalsError: 'No se pudieron cargar los profesionales',
    loadPatientsError: 'No se pudieron cargar los pacientes',
    patientSavedFormError: 'Paciente guardado, pero no se pudo actualizar el formulario',
    shareError: 'No se pudo generar el enlace para compartir',
    professionalFallback: 'Profesional'
  },
  confirmation: {
    title: 'Enlace de confirmación listo',
    created: 'Cita creada:',
    patient: 'Paciente:',
    professional: 'Profesional:',
    date: 'Fecha:',
    time: 'Horario:',
    procedure: 'Procedimiento:',
    link: 'Enlace de confirmación:',
    copy: 'Copiar',
    copied: '¡Copiado!',
    linkHint: 'Envíe este enlace para que el paciente confirme o cancele',
    whatsapp: 'Mensaje para WhatsApp:',
    camera: 'Compartir con la cámara',
    qrLabel: 'Código QR para abrir el mensaje en WhatsApp',
    cameraHint: 'Apunte la cámara para abrir WhatsApp en este número con el mensaje de arriba.',
    sendWhatsapp: 'Enviar por WhatsApp',
    copyMessage: 'Copiar mensaje',
    howTo: 'Cómo usarlo',
    step1: 'El paciente abre el enlace sin iniciar sesión',
    step2: 'Puede confirmar o cancelar desde el propio enlace',
    step3: 'Cada cita tiene un token único',
    step4: 'El estado se actualiza solo en la clínica',
    close: 'Cerrar',
    linkCopied: 'Enlace copiado al portapapeles.',
    copyLinkError: 'No se pudo copiar el enlace',
    messageCopied: 'Mensaje copiado al portapapeles.',
    copyMessageError: 'No se pudo copiar el mensaje'
  },
  chart: {
    open: 'Ficha',
    openTitle: 'Abrir ficha del paciente',
    missing: 'Paciente no encontrado en el registro. Regístrelo en Pacientes para abrir la ficha.',
    openError: 'No se pudo abrir la ficha del paciente'
  },
  patients: {
    mine: 'Mis pacientes',
    title: 'Gestionar pacientes',
    mineSubtitle: 'Gestione sus pacientes',
    subtitle: 'Gestione todos los pacientes de la clínica',
    new: 'Nuevo paciente',
    list: 'Pacientes ({count})',
    search: 'Buscar pacientes',
    searchPlaceholder: 'Nombre, correo o teléfono',
    filterStatus: 'Filtrar por estado',
    active: 'Activos',
    inactive: 'Inactivos',
    all: 'Todos',
    empty: 'No se encontraron pacientes',
    activeBadge: 'Activo',
    inactiveBadge: 'Inactivo',
    notInformed: 'No informado',
    invalidDate: 'Fecha inválida',
    professionalLine: 'Profesional: {name}',
    unassigned: 'Sin asignar',
    notes: 'Observaciones: {notes}',
    clinicalNotes: '{count} nota(s) clínica(s)',
    view: 'Ver ficha',
    edit: 'Editar paciente',
    deactivate: 'Desactivar paciente',
    activate: 'Activar paciente',
    showing: 'Mostrando {start}–{end} de {total}',
    previous: 'Anterior',
    next: 'Siguiente',
    prevPage: 'Página anterior',
    nextPage: 'Página siguiente',
    page: 'Página {page} de {total}',
    activated: 'Paciente activado.',
    deactivated: 'Paciente desactivado.',
    toggleError: 'No se pudo cambiar el estado del paciente',
    noClinicTitle: 'Ninguna clínica seleccionada',
    noClinicBody: 'Seleccione una clínica para continuar.'
  },
  patientChart: {
    notFound: 'Paciente no encontrado',
    notFoundBody: 'La ficha no existe o pertenece a otra clínica.',
    back: 'Volver a pacientes',
    breadcrumb: 'Ruta',
    patients: 'Pacientes',
    record: 'Ficha',
    subtitle: 'Ficha e historial de consultas',
    sections: 'Secciones de la ficha',
    loadError: 'No se pudo cargar la ficha',
    mediaError: 'No se pudieron cargar los medios',
    overview: 'Visión general',
    odontogram: 'Odontograma',
    hof: 'HOF',
    ortho: 'Ortodoncia',
    media: 'Medios',
    overviewTitle: 'Visión general',
    overviewBody: 'Identificación, información clínica y registros de la ficha.',
    editRegistration: 'Editar registro'
  },
  users: {
    title: 'Gestión de usuarios',
    subtitle: 'Gestione profesionales, secretarias y administradores',
    newInvite: 'Nueva invitación',
    tabs: 'Pestañas',
    usersCount: 'Usuarios ({count})',
    invitesShort: 'Invitaciones ({count})',
    invites: 'Invitaciones pendientes ({count})',
    edit: 'Editar usuario',
    name: 'Nombre',
    nameRequired: 'El nombre es obligatorio',
    namePlaceholder: 'Nombre completo',
    email: 'Correo',
    emailRequired: 'El correo es obligatorio',
    emailInvalid: 'Correo inválido',
    emailPlaceholder: 'correo@ejemplo.com',
    phone: 'Teléfono',
    newPassword: 'Nueva contraseña (déjela en blanco para mantener la actual)',
    passwordShort: 'La contraseña debe tener al menos 6 caracteres',
    passwordPlaceholder: 'Nueva contraseña (opcional)',
    role: 'Función',
    roleRequired: 'La función es obligatoria',
    selectRole: 'Seleccione una función',
    admin: 'Administrador',
    professional: 'Profesional',
    secretary: 'Secretaria',
    secretaryLocked: 'El plan Individual no incluye secretarias.',
    active: 'Usuario activo',
    specialty: 'Especialidad',
    selectSpecialty: 'Seleccione la especialidad',
    duration: 'Duración estándar de las consultas',
    minutes: '{count} minutos',
    hoursHint: 'Estos horarios se aplican automáticamente cuando el usuario acepta la invitación.',
    clinicDefaultHours: 'Usando los horarios estándar de la clínica',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    update: 'Actualizar',
    create: 'Crear',
    deactivate: 'Desactivar usuario',
    activate: 'Activar usuario',
    editUser: 'Editar usuario',
    deleteUser: 'Eliminar usuario',
    inviteCreatedOn: 'Invitación creada el {date}',
    sendingEmail: 'Enviando correo...',
    sendEmail: 'Enviar invitación por correo',
    copyLink: 'Copiar enlace de la invitación',
    cancelInvite: 'Cancelar invitación',
    deleteInvite: 'Eliminar invitación',
    noClinic: 'Ninguna clínica seleccionada',
    noClinicTitle: 'Ninguna clínica seleccionada',
    noClinicBody: 'Seleccione una clínica para continuar.',
    deniedTitle: 'Acceso denegado',
    deniedBody: 'No tiene permiso para gestionar usuarios.',
    updated: 'Usuario actualizado.',
    inviteCreated: 'Invitación creada. Enlace copiado y correo enviado.',
    saveError: 'No se pudo guardar: {message}',
    emailSent: 'Correo de invitación enviado',
    emailError: 'No se pudo enviar el correo',
    confirmDeactivate: '¿Desactivar este usuario?',
    deactivated: 'Usuario desactivado.',
    deleteError: 'No se pudo eliminar el usuario',
    activated: 'Usuario activado.',
    userDeactivated: 'Usuario desactivado.',
    statusError: 'No se pudo cambiar el estado del usuario',
    linkCopied: 'Enlace copiado al portapapeles.',
    copyError: 'No se pudo copiar el enlace',
    confirmCancelInvite: '¿Cancelar esta invitación?',
    inviteCancelled: 'Invitación cancelada.',
    cancelInviteError: 'No se pudo cancelar la invitación',
    confirmDeleteInvite: '¿Eliminar esta invitación?',
    inviteDeleted: 'Invitación eliminada.',
    deleteInviteError: 'No se pudo eliminar la invitación'
  },
  settings: {
    title: 'Configuración',
    subtitle: 'Perfil de la clínica, suscripción, agenda estándar y mensaje de confirmación',
    readOnly: 'Puede ver la configuración. Solo los administradores pueden editarla.',
    clinic: 'Datos de la clínica',
    name: 'Nombre',
    description: 'Descripción',
    address: 'Dirección',
    phone: 'Teléfono',
    email: 'Correo',
    cnpj: 'CNPJ',
    schedule: 'Agenda estándar',
    duration: 'Duración estándar (minutos)',
    interval: 'Intervalo de la grilla',
    minutes: '{count} min',
    hoursHint: 'Se usa cuando el profesional aún no tiene horarios propios.',
    confirmation: 'Mensaje de confirmación',
    variables: 'Variables: {paciente}, {profissional}, {data}, {horario}, {link}',
    saving: 'Guardando...',
    save: 'Guardar configuración',
    noClinic: 'Ninguna clínica seleccionada',
    noClinicTitle: 'Ninguna clínica seleccionada',
    noClinicBody: 'Seleccione una clínica para gestionar la configuración.',
    adminOnly: 'Solo los administradores pueden cambiar la configuración',
    saved: 'Configuración guardada',
    saveError: 'No se pudo guardar la configuración: {message}'
  },
  billing: {
    title: 'Suscripción y pago',
    plan: 'Plan',
    noPaidPlan: 'Ningún plan de pago',
    status: 'Estado',
    tester: 'Cuenta de prueba',
    method: 'Método',
    methodPix: 'Pix (OpenPix)',
    methodCard: 'Tarjeta (Stripe)',
    cycle: 'Ciclo',
    annual: 'Anual',
    monthly: 'Mensual',
    perMonth: '/mes',
    renewal: 'Próxima renovación',
    notConfigured: 'El pago aún no tiene credenciales. Stripe (tarjeta) y OpenPix (Pix) se pueden conectar después del registro.',
    renew: 'Renovar plan',
    subscribe: 'Suscribirse',
    opening: 'Abriendo...',
    portal: 'Gestionar en el portal de Stripe',
    portalError: 'No se pudo abrir el portal de Stripe',
    refresh: 'Actualizar estado',
    bannerStatus: 'Suscripción: {status}',
    bannerBody: 'Regularice el pago para mantener activo el plan de la clínica.',
    bannerCta: 'Ir al checkout',
    sub: {
      active: 'Activa',
      trialing: 'Período de prueba',
      past_due: 'Pago atrasado',
      unpaid: 'No pagada',
      canceled: 'Cancelada',
      incomplete: 'Incompleta',
      incomplete_expired: 'Expirada',
      none: 'Sin suscripción'
    }
  },
  auth: {
    backHome: 'Volver al inicio',
    createAccount: 'Crear cuenta',
    subtitle: 'Sistema de citas',
    email: 'Correo',
    emailPlaceholder: 'su@correo.com',
    password: 'Contraseña',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    signingIn: 'Entrando...',
    signIn: 'Entrar',
    forgot: 'Olvidé mi contraseña',
    noAccount: '¿No tiene una cuenta?',
    createAdmin: 'Cree una cuenta de administrador',
    toStart: 'para empezar.',
    fillAll: 'Complete todos los campos',
    signedIn: 'Sesión iniciada.',
    badCredentials: 'Correo o contraseña incorrectos.',
    tooMany: 'Demasiados intentos. Inténtelo de nuevo en unos minutos.',
    loginError: 'Error al entrar. Verifique sus credenciales.',
    backLogin: 'Volver al inicio de sesión',
    resetTitle: 'Recupere su contraseña',
    resetBody: 'Indique el correo de su cuenta. Si está registrado, enviaremos un enlace para crear una nueva contraseña.',
    resetSent: 'Si el correo está registrado, recibirá las instrucciones enseguida. El enlace expira en 1 hora.',
    sending: 'Enviando...',
    sendLink: 'Enviar enlace',
    resetError: 'No se pudo enviar el correo de recuperación.'
  }
};

export const shellPages = {
  'pt-BR': shellPt,
  en: shellEn,
  es: shellEs
};
